var REACT_ELEMENT_TYPE;
function _jsx(e, t, r, n) {
    REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE || ("function" == typeof Symbol && Symbol.for && Symbol.for("react.element")) || 60103;
    var o = e && e.defaultProps,
        i = arguments.length - 3;
    if ((t || 0 == i || (t = { children: void 0 }), 1 == i)) t.children = n;
    else if (1 < i) {
        for (var a = new Array(i), c = 0; c < i; c++) a[c] = arguments[c + 3];
        t.children = a;
    }
    if (t && o) for (var s in o) void 0 === t[s] && (t[s] = o[s]);
    else t = t || o || {};
    return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === r ? null : "" + r, ref: null, props: t, _owner: null };
}
function ownKeys(t, e) {
    var r,
        n = Object.keys(t);
    return (
        Object.getOwnPropertySymbols &&
            ((r = Object.getOwnPropertySymbols(t)),
            e &&
                (r = r.filter(function (e) {
                    return Object.getOwnPropertyDescriptor(t, e).enumerable;
                })),
            n.push.apply(n, r)),
        n
    );
}
function _objectSpread2(t) {
    for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2
            ? ownKeys(Object(r), !0).forEach(function (e) {
                  _defineProperty(t, e, r[e]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r))
            : ownKeys(Object(r)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
              });
    }
    return t;
}
function _typeof(e) {
    return (_typeof =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                  return typeof e;
              }
            : function (e) {
                  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
              })(e);
}
function _wrapRegExp() {
    _wrapRegExp = function (e, t) {
        return new n(e, void 0, t);
    };
    var o = RegExp.prototype,
        i = new WeakMap();
    function n(e, t, r) {
        t = new RegExp(e, t);
        return i.set(t, r || i.get(e)), _setPrototypeOf(t, n.prototype);
    }
    function a(r, e) {
        var n = i.get(e);
        return Object.keys(n).reduce(function (e, t) {
            return (e[t] = r[n[t]]), e;
        }, Object.create(null));
    }
    return (
        _inherits(n, RegExp),
        (n.prototype.exec = function (e) {
            e = o.exec.call(this, e);
            return e && (e.groups = a(e, this)), e;
        }),
        (n.prototype[Symbol.replace] = function (e, t) {
            if ("string" == typeof t) {
                var r = i.get(this);
                return o[Symbol.replace].call(
                    this,
                    e,
                    t.replace(/\$<([^>]+)>/g, function (e, t) {
                        return "$" + r[t];
                    })
                );
            }
            if ("function" != typeof t) return o[Symbol.replace].call(this, e, t);
            var n = this;
            return o[Symbol.replace].call(this, e, function () {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(a(e, n)), t.apply(this, e);
            });
        }),
        _wrapRegExp.apply(this, arguments)
    );
}
function _asyncIterator(e) {
    var t;
    if (null == (t = null == (t = null == (t = "undefined" != typeof Symbol && null == (t = Symbol.asyncIterator ? e[Symbol.asyncIterator] : t) && Symbol.iterator ? e[Symbol.iterator] : t) ? e["@@asyncIterator"] : t) ? e["@@iterator"] : t))
        throw new TypeError("Object is not async iterable");
    return t.call(e);
}
function _AwaitValue(e) {
    this.wrapped = e;
}
function _AsyncGenerator(i) {
    var o, a;
    function c(t, e) {
        try {
            var r = i[t](e),
                n = r.value,
                o = n instanceof _AwaitValue;
            Promise.resolve(o ? n.wrapped : n).then(
                function (e) {
                    o ? c("return" === t ? "return" : "next", e) : s(r.done ? "return" : "normal", e);
                },
                function (e) {
                    c("throw", e);
                }
            );
        } catch (e) {
            s("throw", e);
        }
    }
    function s(e, t) {
        switch (e) {
            case "return":
                o.resolve({ value: t, done: !0 });
                break;
            case "throw":
                o.reject(t);
                break;
            default:
                o.resolve({ value: t, done: !1 });
        }
        (o = o.next) ? c(o.key, o.arg) : (a = null);
    }
    (this._invoke = function (r, n) {
        return new Promise(function (e, t) {
            t = { key: r, arg: n, resolve: e, reject: t, next: null };
            a ? (a = a.next = t) : ((o = a = t), c(r, n));
        });
    }),
        "function" != typeof i.return && (this.return = void 0);
}
function _wrapAsyncGenerator(e) {
    return function () {
        return new _AsyncGenerator(e.apply(this, arguments));
    };
}
function _awaitAsyncGenerator(e) {
    return new _AwaitValue(e);
}
function _asyncGeneratorDelegate(n, e) {
    var t = {},
        o = !1;
    function r(t, r) {
        return (
            (o = !0),
            (r = new Promise(function (e) {
                e(n[t](r));
            })),
            { done: !1, value: e(r) }
        );
    }
    return (
        (t[("undefined" != typeof Symbol && Symbol.iterator) || "@@iterator"] = function () {
            return this;
        }),
        (t.next = function (e) {
            return o ? ((o = !1), e) : r("next", e);
        }),
        "function" == typeof n.throw &&
            (t.throw = function (e) {
                if (o) throw ((o = !1), e);
                return r("throw", e);
            }),
        "function" == typeof n.return &&
            (t.return = function (e) {
                return o ? ((o = !1), e) : r("return", e);
            }),
        t
    );
}
function asyncGeneratorStep(e, t, r, n, o, i, a) {
    try {
        var c = e[i](a),
            s = c.value;
    } catch (e) {
        return void r(e);
    }
    c.done ? t(s) : Promise.resolve(s).then(n, o);
}
function _asyncToGenerator(c) {
    return function () {
        var e = this,
            a = arguments;
        return new Promise(function (t, r) {
            var n = c.apply(e, a);
            function o(e) {
                asyncGeneratorStep(n, t, r, o, i, "next", e);
            }
            function i(e) {
                asyncGeneratorStep(n, t, r, o, i, "throw", e);
            }
            o(void 0);
        });
    };
}
function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
    for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function _createClass(e, t, r) {
    return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
function _defineEnumerableProperties(e, t) {
    for (var r in t) ((i = t[r]).configurable = i.enumerable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, r, i);
    if (Object.getOwnPropertySymbols)
        for (var n = Object.getOwnPropertySymbols(t), o = 0; o < n.length; o++) {
            var i,
                a = n[o];
            ((i = t[a]).configurable = i.enumerable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, a, i);
        }
    return e;
}
function _defaults(e, t) {
    for (var r = Object.getOwnPropertyNames(t), n = 0; n < r.length; n++) {
        var o = r[n],
            i = Object.getOwnPropertyDescriptor(t, o);
        i && i.configurable && void 0 === e[o] && Object.defineProperty(e, o, i);
    }
    return e;
}
function _defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = r), e;
}
function _extends() {
    return (_extends =
        Object.assign ||
        function (e) {
            for (var t = 1; t < arguments.length; t++) {
                var r,
                    n = arguments[t];
                for (r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
        }).apply(this, arguments);
}
function _objectSpread(t) {
    for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? Object(arguments[e]) : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols &&
            n.push.apply(
                n,
                Object.getOwnPropertySymbols(r).filter(function (e) {
                    return Object.getOwnPropertyDescriptor(r, e).enumerable;
                })
            ),
            n.forEach(function (e) {
                _defineProperty(t, e, r[e]);
            });
    }
    return t;
}
function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })), t && _setPrototypeOf(e, t);
}
function _inheritsLoose(e, t) {
    (e.prototype = Object.create(t.prototype)), _setPrototypeOf((e.prototype.constructor = e), t);
}
function _getPrototypeOf(e) {
    return (_getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
}
function _setPrototypeOf(e, t) {
    return (_setPrototypeOf =
        Object.setPrototypeOf ||
        function (e, t) {
            return (e.__proto__ = t), e;
        })(e, t);
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
        return !1;
    }
}
function _construct(e, t, r) {
    return (_construct = _isNativeReflectConstruct()
        ? Reflect.construct
        : function (e, t, r) {
              var n = [null];
              n.push.apply(n, t);
              n = new (Function.bind.apply(e, n))();
              return r && _setPrototypeOf(n, r.prototype), n;
          }).apply(null, arguments);
}
function _isNativeFunction(e) {
    return -1 !== Function.toString.call(e).indexOf("[native code]");
}
function _wrapNativeSuper(e) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return (_wrapNativeSuper = function (e) {
        if (null === e || !_isNativeFunction(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(e)) return r.get(e);
            r.set(e, t);
        }
        function t() {
            return _construct(e, arguments, _getPrototypeOf(this).constructor);
        }
        return (t.prototype = Object.create(e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } })), _setPrototypeOf(t, e);
    })(e);
}
function _instanceof(e, t) {
    return null != t && "undefined" != typeof Symbol && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
}
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var t = new WeakMap(),
        r = new WeakMap();
    return (_getRequireWildcardCache = function (e) {
        return e ? r : t;
    })(e);
}
function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    if (null === e || ("object" != typeof e && "function" != typeof e)) return { default: e };
    t = _getRequireWildcardCache(t);
    if (t && t.has(e)) return t.get(e);
    var r,
        n,
        o = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && ((n = i ? Object.getOwnPropertyDescriptor(e, r) : null) && (n.get || n.set) ? Object.defineProperty(o, r, n) : (o[r] = e[r]));
    return (o.default = e), t && t.set(e, o), o;
}
function _newArrowCheck(e, t) {
    if (e !== t) throw new TypeError("Cannot instantiate an arrow function");
}
function _objectDestructuringEmpty(e) {
    if (null == e) throw new TypeError("Cannot destructure undefined");
}
function _objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    for (var r, n = {}, o = Object.keys(e), i = 0; i < o.length; i++) (r = o[i]), 0 <= t.indexOf(r) || (n[r] = e[r]);
    return n;
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var r,
        n = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) for (var o = Object.getOwnPropertySymbols(e), i = 0; i < o.length; i++) (r = o[i]), 0 <= t.indexOf(r) || (Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]));
    return n;
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _possibleConstructorReturn(e, t) {
    if (t && ("object" == typeof t || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(e);
}
function _createSuper(r) {
    var n = _isNativeReflectConstruct();
    return function () {
        var e,
            t = _getPrototypeOf(r);
        return _possibleConstructorReturn(this, n ? ((e = _getPrototypeOf(this).constructor), Reflect.construct(t, arguments, e)) : t.apply(this, arguments));
    };
}
function _superPropBase(e, t) {
    for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = _getPrototypeOf(e)); );
    return e;
}
function _get(e, t, r) {
    return (_get =
        "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (e, t, r) {
                  e = _superPropBase(e, t);
                  if (e) {
                      t = Object.getOwnPropertyDescriptor(e, t);
                      return t.get ? t.get.call(r) : t.value;
                  }
              })(e, t, r || e);
}
function set(e, t, r, n) {
    return (set =
        "undefined" != typeof Reflect && Reflect.set
            ? Reflect.set
            : function (e, t, r, n) {
                  var o,
                      e = _superPropBase(e, t);
                  if (e) {
                      if ((o = Object.getOwnPropertyDescriptor(e, t)).set) return o.set.call(n, r), !0;
                      if (!o.writable) return !1;
                  }
                  if ((o = Object.getOwnPropertyDescriptor(n, t))) {
                      if (!o.writable) return !1;
                      (o.value = r), Object.defineProperty(n, t, o);
                  } else _defineProperty(n, t, r);
                  return !0;
              })(e, t, r, n);
}
function _set(e, t, r, n, o) {
    if (!set(e, t, r, n || e) && o) throw new Error("failed to set property");
    return r;
}
function _taggedTemplateLiteral(e, t) {
    return (t = t || e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function _taggedTemplateLiteralLoose(e, t) {
    return (t = t || e.slice(0)), (e.raw = t), e;
}
function _readOnlyError(e) {
    throw new TypeError('"' + e + '" is read-only');
}
function _writeOnlyError(e) {
    throw new TypeError('"' + e + '" is write-only');
}
function _classNameTDZError(e) {
    throw new Error('Class "' + e + '" cannot be referenced in computed property keys.');
}
function _temporalUndefined() {}
function _tdz(e) {
    throw new ReferenceError(e + " is not defined - temporal dead zone");
}
function _temporalRef(e, t) {
    return e === _temporalUndefined ? _tdz(t) : e;
}
function _slicedToArray(e, t) {
    return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _slicedToArrayLoose(e, t) {
    return _arrayWithHoles(e) || _iterableToArrayLimitLoose(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}
function _toArray(e) {
    return _arrayWithHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableRest();
}
function _toConsumableArray(e) {
    return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}
function _arrayWithoutHoles(e) {
    if (Array.isArray(e)) return _arrayLikeToArray(e);
}
function _arrayWithHoles(e) {
    if (Array.isArray(e)) return e;
}
function _maybeArrayLike(e, t, r) {
    if (!t || Array.isArray(t) || "number" != typeof t.length) return e(t, r);
    e = t.length;
    return _arrayLikeToArray(t, void 0 !== r && r < e ? r : e);
}
function _iterableToArray(e) {
    if (("undefined" != typeof Symbol && null != e[Symbol.iterator]) || null != e["@@iterator"]) return Array.from(e);
}
function _iterableToArrayLimit(e, t) {
    var r = null == e ? null : ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
    if (null != r) {
        var n,
            o,
            i = [],
            a = !0,
            c = !1;
        try {
            for (r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
        } catch (e) {
            (c = !0), (o = e);
        } finally {
            try {
                a || null == r.return || r.return();
            } finally {
                if (c) throw o;
            }
        }
        return i;
    }
}
function _iterableToArrayLimitLoose(e, t) {
    if (null != (n = e && (("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"]))) {
        var r = [],
            n = n.call(e);
        for (_step; !(_step = n.next()).done && (r.push(_step.value), !t || r.length !== t); );
        return r;
    }
}
function _unsupportedIterableToArray(e, t) {
    if (e) {
        if ("string" == typeof e) return _arrayLikeToArray(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Map" === (r = "Object" === r && e.constructor ? e.constructor.name : r) || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
    }
}
function _arrayLikeToArray(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(e, t) {
    var r = ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
    if (!r) {
        if (Array.isArray(e) || (r = _unsupportedIterableToArray(e)) || (t && e && "number" == typeof e.length)) {
            r && (e = r);
            function n() {}
            var o = 0;
            return {
                s: n,
                n: function () {
                    return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
                },
                e: function (e) {
                    throw e;
                },
                f: n,
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var i,
        a = !0,
        c = !1;
    return {
        s: function () {
            r = r.call(e);
        },
        n: function () {
            var e = r.next();
            return (a = e.done), e;
        },
        e: function (e) {
            (c = !0), (i = e);
        },
        f: function () {
            try {
                a || null == r.return || r.return();
            } finally {
                if (c) throw i;
            }
        },
    };
}
function _createForOfIteratorHelperLoose(e, t) {
    var r = ("undefined" != typeof Symbol && e[Symbol.iterator]) || e["@@iterator"];
    if (r) return (r = r.call(e)).next.bind(r);
    if (Array.isArray(e) || (r = _unsupportedIterableToArray(e)) || (t && e && "number" == typeof e.length)) {
        r && (e = r);
        var n = 0;
        return function () {
            return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _skipFirstGeneratorNext(t) {
    return function () {
        var e = t.apply(this, arguments);
        return e.next(), e;
    };
}
function _toPrimitive(e, t) {
    if ("object" != typeof e || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 === r) return ("string" === t ? String : Number)(e);
    t = r.call(e, t || "default");
    if ("object" != typeof t) return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
}
function _toPropertyKey(e) {
    e = _toPrimitive(e, "string");
    return "symbol" == typeof e ? e : String(e);
}
function _initializerWarningHelper(e, t) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.");
}
function _initializerDefineProperty(e, t, r, n) {
    r && Object.defineProperty(e, t, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(n) : void 0 });
}
function _applyDecoratedDescriptor(r, n, e, t, o) {
    var i = {};
    return (
        Object.keys(t).forEach(function (e) {
            i[e] = t[e];
        }),
        (i.enumerable = !!i.enumerable),
        (i.configurable = !!i.configurable),
        ("value" in i || i.initializer) && (i.writable = !0),
        (i = e
            .slice()
            .reverse()
            .reduce(function (e, t) {
                return t(r, n, e) || e;
            }, i)),
        o && void 0 !== i.initializer && ((i.value = i.initializer ? i.initializer.call(o) : void 0), (i.initializer = void 0)),
        void 0 === i.initializer && (Object.defineProperty(r, n, i), (i = null)),
        i
    );
}
(_AsyncGenerator.prototype[("function" == typeof Symbol && Symbol.asyncIterator) || "@@asyncIterator"] = function () {
    return this;
}),
    (_AsyncGenerator.prototype.next = function (e) {
        return this._invoke("next", e);
    }),
    (_AsyncGenerator.prototype.throw = function (e) {
        return this._invoke("throw", e);
    }),
    (_AsyncGenerator.prototype.return = function (e) {
        return this._invoke("return", e);
    });
var id = 0;
function _classPrivateFieldLooseKey(e) {
    return "__private_" + id++ + "_" + e;
}
function _classPrivateFieldLooseBase(e, t) {
    if (!Object.prototype.hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
function _classPrivateFieldGet(e, t) {
    return _classApplyDescriptorGet(e, _classExtractFieldDescriptor(e, t, "get"));
}
function _classPrivateFieldSet(e, t, r) {
    return _classApplyDescriptorSet(e, _classExtractFieldDescriptor(e, t, "set"), r), r;
}
function _classPrivateFieldDestructureSet(e, t) {
    return _classApplyDescriptorDestructureSet(e, _classExtractFieldDescriptor(e, t, "set"));
}
function _classExtractFieldDescriptor(e, t, r) {
    if (!t.has(e)) throw new TypeError("attempted to " + r + " private field on non-instance");
    return t.get(e);
}
function _classStaticPrivateFieldSpecGet(e, t, r) {
    return _classCheckPrivateStaticAccess(e, t), _classCheckPrivateStaticFieldDescriptor(r, "get"), _classApplyDescriptorGet(e, r);
}
function _classStaticPrivateFieldSpecSet(e, t, r, n) {
    return _classCheckPrivateStaticAccess(e, t), _classCheckPrivateStaticFieldDescriptor(r, "set"), _classApplyDescriptorSet(e, r, n), n;
}
function _classStaticPrivateMethodGet(e, t, r) {
    return _classCheckPrivateStaticAccess(e, t), r;
}
function _classStaticPrivateMethodSet() {
    throw new TypeError("attempted to set read only static private field");
}
function _classApplyDescriptorGet(e, t) {
    return t.get ? t.get.call(e) : t.value;
}
function _classApplyDescriptorSet(e, t, r) {
    if (t.set) t.set.call(e, r);
    else {
        if (!t.writable) throw new TypeError("attempted to set read only private field");
        t.value = r;
    }
}
function _classApplyDescriptorDestructureSet(t, r) {
    if (r.set)
        return (
            "__destrObj" in r ||
                (r.__destrObj = {
                    set value(e) {
                        r.set.call(t, e);
                    },
                }),
            r.__destrObj
        );
    if (!r.writable) throw new TypeError("attempted to set read only private field");
    return r;
}
function _classStaticPrivateFieldDestructureSet(e, t, r) {
    return _classCheckPrivateStaticAccess(e, t), _classCheckPrivateStaticFieldDescriptor(r, "set"), _classApplyDescriptorDestructureSet(e, r);
}
function _classCheckPrivateStaticAccess(e, t) {
    if (e !== t) throw new TypeError("Private static access of wrong provenance");
}
function _classCheckPrivateStaticFieldDescriptor(e, t) {
    if (void 0 === e) throw new TypeError("attempted to " + t + " private static field before its declaration");
}
function _decorate(e, t, r, n) {
    var o = _getDecoratorsApi();
    if (n) for (var i = 0; i < n.length; i++) o = n[i](o);
    var r = t(function (e) {
            o.initializeInstanceElements(e, a.elements);
        }, r),
        a = o.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), e);
    return o.initializeClassElements(r.F, a.elements), o.runClassFinishers(r.F, a.finishers);
}
function _getDecoratorsApi() {
    _getDecoratorsApi = function () {
        return e;
    };
    var e = {
        elementsDefinitionOrder: [["method"], ["field"]],
        initializeInstanceElements: function (r, e) {
            ["method", "field"].forEach(function (t) {
                e.forEach(function (e) {
                    e.kind === t && "own" === e.placement && this.defineClassElement(r, e);
                }, this);
            }, this);
        },
        initializeClassElements: function (n, e) {
            var o = n.prototype;
            ["method", "field"].forEach(function (r) {
                e.forEach(function (e) {
                    var t = e.placement;
                    e.kind !== r || ("static" !== t && "prototype" !== t) || this.defineClassElement("static" === t ? n : o, e);
                }, this);
            }, this);
        },
        defineClassElement: function (e, t) {
            var r,
                n = t.descriptor;
            "field" === t.kind && ((r = t.initializer), (n = { enumerable: n.enumerable, writable: n.writable, configurable: n.configurable, value: void 0 === r ? void 0 : r.call(e) })), Object.defineProperty(e, t.key, n);
        },
        decorateClass: function (e, t) {
            var r = [],
                n = [],
                o = { static: [], prototype: [], own: [] };
            if (
                (e.forEach(function (e) {
                    this.addElementPlacement(e, o);
                }, this),
                e.forEach(function (e) {
                    if (!_hasDecorators(e)) return r.push(e);
                    e = this.decorateElement(e, o);
                    r.push(e.element), r.push.apply(r, e.extras), n.push.apply(n, e.finishers);
                }, this),
                !t)
            )
                return { elements: r, finishers: n };
            t = this.decorateConstructor(r, t);
            return n.push.apply(n, t.finishers), (t.finishers = n), t;
        },
        addElementPlacement: function (e, t, r) {
            t = t[e.placement];
            if (!r && -1 !== t.indexOf(e.key)) throw new TypeError("Duplicated element (" + e.key + ")");
            t.push(e.key);
        },
        decorateElement: function (e, t) {
            for (var r = [], n = [], o = e.decorators, i = o.length - 1; 0 <= i; i--) {
                var a = t[e.placement];
                a.splice(a.indexOf(e.key), 1);
                (a = this.fromElementDescriptor(e)), (a = this.toElementFinisherExtras((0, o[i])(a) || a));
                (e = a.element), this.addElementPlacement(e, t), a.finisher && n.push(a.finisher);
                var c = a.extras;
                if (c) {
                    for (var s = 0; s < c.length; s++) this.addElementPlacement(c[s], t);
                    r.push.apply(r, c);
                }
            }
            return { element: e, finishers: n, extras: r };
        },
        decorateConstructor: function (e, t) {
            for (var r = [], n = t.length - 1; 0 <= n; n--) {
                var o = this.fromClassDescriptor(e),
                    o = this.toClassDescriptor((0, t[n])(o) || o);
                if ((void 0 !== o.finisher && r.push(o.finisher), void 0 !== o.elements)) {
                    e = o.elements;
                    for (var i = 0; i < e.length - 1; i++) for (var a = i + 1; a < e.length; a++) if (e[i].key === e[a].key && e[i].placement === e[a].placement) throw new TypeError("Duplicated element (" + e[i].key + ")");
                }
            }
            return { elements: e, finishers: r };
        },
        fromElementDescriptor: function (e) {
            var t = { kind: e.kind, key: e.key, placement: e.placement, descriptor: e.descriptor };
            return Object.defineProperty(t, Symbol.toStringTag, { value: "Descriptor", configurable: !0 }), "field" === e.kind && (t.initializer = e.initializer), t;
        },
        toElementDescriptors: function (e) {
            if (void 0 !== e)
                return _toArray(e).map(function (e) {
                    var t = this.toElementDescriptor(e);
                    return this.disallowProperty(e, "finisher", "An element descriptor"), this.disallowProperty(e, "extras", "An element descriptor"), t;
                }, this);
        },
        toElementDescriptor: function (e) {
            var t = String(e.kind);
            if ("method" !== t && "field" !== t) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + t + '"');
            var r = _toPropertyKey(e.key),
                n = String(e.placement);
            if ("static" !== n && "prototype" !== n && "own" !== n)
                throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + n + '"');
            var o = e.descriptor;
            this.disallowProperty(e, "elements", "An element descriptor");
            n = { kind: t, key: r, placement: n, descriptor: Object.assign({}, o) };
            return (
                "field" !== t
                    ? this.disallowProperty(e, "initializer", "A method descriptor")
                    : (this.disallowProperty(o, "get", "The property descriptor of a field descriptor"),
                      this.disallowProperty(o, "set", "The property descriptor of a field descriptor"),
                      this.disallowProperty(o, "value", "The property descriptor of a field descriptor"),
                      (n.initializer = e.initializer)),
                n
            );
        },
        toElementFinisherExtras: function (e) {
            return { element: this.toElementDescriptor(e), finisher: _optionalCallableProperty(e, "finisher"), extras: this.toElementDescriptors(e.extras) };
        },
        fromClassDescriptor: function (e) {
            e = { kind: "class", elements: e.map(this.fromElementDescriptor, this) };
            return Object.defineProperty(e, Symbol.toStringTag, { value: "Descriptor", configurable: !0 }), e;
        },
        toClassDescriptor: function (e) {
            var t = String(e.kind);
            if ("class" !== t) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + t + '"');
            this.disallowProperty(e, "key", "A class descriptor"),
                this.disallowProperty(e, "placement", "A class descriptor"),
                this.disallowProperty(e, "descriptor", "A class descriptor"),
                this.disallowProperty(e, "initializer", "A class descriptor"),
                this.disallowProperty(e, "extras", "A class descriptor");
            t = _optionalCallableProperty(e, "finisher");
            return { elements: this.toElementDescriptors(e.elements), finisher: t };
        },
        runClassFinishers: function (e, t) {
            for (var r = 0; r < t.length; r++) {
                var n = (0, t[r])(e);
                if (void 0 !== n) {
                    if ("function" != typeof n) throw new TypeError("Finishers must return a constructor.");
                    e = n;
                }
            }
            return e;
        },
        disallowProperty: function (e, t, r) {
            if (void 0 !== e[t]) throw new TypeError(r + " can't have a ." + t + " property.");
        },
    };
    return e;
}
function _createElementDescriptor(e) {
    var t = _toPropertyKey(e.key);
    "method" === e.kind
        ? (r = { value: e.value, writable: !0, configurable: !0, enumerable: !1 })
        : "get" === e.kind
        ? (r = { get: e.value, configurable: !0, enumerable: !1 })
        : "set" === e.kind
        ? (r = { set: e.value, configurable: !0, enumerable: !1 })
        : "field" === e.kind && (r = { configurable: !0, writable: !0, enumerable: !0 });
    var r = { kind: "field" === e.kind ? "field" : "method", key: t, placement: e.static ? "static" : "field" === e.kind ? "own" : "prototype", descriptor: r };
    return e.decorators && (r.decorators = e.decorators), "field" === e.kind && (r.initializer = e.value), r;
}
function _coalesceGetterSetter(e, t) {
    void 0 !== e.descriptor.get ? (t.descriptor.get = e.descriptor.get) : (t.descriptor.set = e.descriptor.set);
}
function _coalesceClassElements(e) {
    function t(e) {
        return "method" === e.kind && e.key === i.key && e.placement === i.placement;
    }
    for (var r = [], n = 0; n < e.length; n++) {
        var o,
            i = e[n];
        if ("method" === i.kind && (o = r.find(t)))
            if (_isDataDescriptor(i.descriptor) || _isDataDescriptor(o.descriptor)) {
                if (_hasDecorators(i) || _hasDecorators(o)) throw new ReferenceError("Duplicated methods (" + i.key + ") can't be decorated.");
                o.descriptor = i.descriptor;
            } else {
                if (_hasDecorators(i)) {
                    if (_hasDecorators(o)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + i.key + ").");
                    o.decorators = i.decorators;
                }
                _coalesceGetterSetter(i, o);
            }
        else r.push(i);
    }
    return r;
}
function _hasDecorators(e) {
    return e.decorators && e.decorators.length;
}
function _isDataDescriptor(e) {
    return void 0 !== e && !(void 0 === e.value && void 0 === e.writable);
}
function _optionalCallableProperty(e, t) {
    e = e[t];
    if (void 0 !== e && "function" != typeof e) throw new TypeError("Expected '" + t + "' to be a function");
    return e;
}
function _classPrivateMethodGet(e, t, r) {
    if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
    return r;
}
function _checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldInitSpec(e, t, r) {
    _checkPrivateRedeclaration(e, t), t.set(e, r);
}
function _classPrivateMethodInitSpec(e, t) {
    _checkPrivateRedeclaration(e, t), t.add(e);
}
function _classPrivateMethodSet() {
    throw new TypeError("attempted to reassign private method");
}
var CartRemoveButton = (function () {
    _inherits(r, _wrapNativeSuper(HTMLElement));
    var e = _createSuper(r);
    function r() {
        var t;
        return (
            _classCallCheck(this, r),
            (t = e.call(this)).addEventListener("click", function (e) {
                e.preventDefault(), t.closest("cart-items").updateQuantity(t.dataset.index, 0, t.dataset.id);
            }),
            t
        );
    }
    return r;
})();
customElements.define("cart-remove-button", CartRemoveButton);
var CartNote = (function () {
    _inherits(n, _wrapNativeSuper(HTMLElement));
    var t = _createSuper(n);
    function n() {
        var e, r;
        return (
            _classCallCheck(this, n),
            ((r = t.call(this)).checkbox = r.querySelector("[data-cart-note-checkbox]")),
            (r.messageWrapper = r.querySelector("[data-cart-note-message]")),
            (r.messageField = r.querySelector("[data-cart-note-message-value]")),
            !0 !== (null === (e = r.checkbox) || void 0 === e ? void 0 : e.checked) && r.clearNote(),
            null !== (e = r.messageField) &&
                void 0 !== e &&
                e.addEventListener(
                    "change",
                    debounce(function (e) {
                        var t;
                        !0 === (null === (t = r.checkbox) || void 0 === t ? void 0 : t.checked) && r.addNote();
                    }),
                    300
                ),
            null !== (e = r.checkbox) &&
                void 0 !== e &&
                e.addEventListener("change", function (e) {
                    var t;
                    !0 === (null === (t = r.checkbox) || void 0 === t ? void 0 : t.checked)
                        ? (r.messageWrapper.classList.add("note__message-wrapper--show"), r.addNote())
                        : ((window.innerWidth < 1200 || !document.body.classList.contains("template-cart")) && r.messageWrapper.classList.remove("note__message-wrapper--show"), r.clearNote());
                }),
            r
        );
    }
    return (
        _createClass(n, [
            {
                key: "addNote",
                value: function () {
                    var e = JSON.stringify({ note: this.messageField.value });
                    fetch("".concat(routes.cart_update_url), _objectSpread2(_objectSpread2({}, fetchConfig()), { body: e }));
                },
            },
            {
                key: "clearNote",
                value: function () {
                    var e = JSON.stringify({ note: "" });
                    fetch("".concat(routes.cart_update_url), _objectSpread2(_objectSpread2({}, fetchConfig()), { body: e }));
                },
            },
        ]),
        n
    );
})();
customElements.define("cart-note", CartNote);
var CartItems = (function () {
    _inherits(r, _wrapNativeSuper(HTMLElement));
    var e = _createSuper(r);
    function r() {
        var t;
        return (
            _classCallCheck(this, r),
            ((t = e.call(this)).cartDrawer = document.querySelector("cart-drawer")),
            (t.cartDrawerSlider = document.querySelector("cart-drawer-slider")),
            (t.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status")),
            (t.loader = document.querySelector(".cart [data-loader]")),
            (t.currentItemCount = Array.from(t.querySelectorAll('[name="updates[]"]')).reduce(function (e, t) {
                return e + parseInt(t.value);
            }, 0)),
            (t.debouncedOnChange = debounce(function (e) {
                t.onChange(e);
            }, 300)),
            t.addEventListener("change", t.debouncedOnChange.bind(_assertThisInitialized(t))),
            window.addEventListener("load", t.reorderBundles.bind(_assertThisInitialized(t))),
            Shopify.designMode &&
                window.addEventListener("shopify:section:select", function (e) {
                    var t = document.querySelectorAll("[data-bundle-group]");
                    1 < t.length &&
                        [].slice
                            .call(t)
                            .sort(function (e, t) {
                                (e = e.dataset.bundleGroup), (t = t.dataset.bundleGroup);
                                return e < t ? -1 : t < e ? 1 : 0;
                            })
                            .forEach(function (e, t) {
                                var r = "bundle-" + e.dataset.bundleGroup;
                                document.getElementById(r).appendChild(e);
                            });
                }),
            t
        );
    }
    return (
        _createClass(r, [
            {
                key: "onChange",
                value: function (e) {
                    this.updateQuantity(e.target.dataset.index, e.target.value, e.target.dataset.id, document.activeElement.getAttribute("name"));
                },
            },
            {
                key: "getSectionsToRender",
                value: function () {
                    return [
                        { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: "#shopify-section-cart-icon-bubble" },
                        { id: "main-cart", section: document.getElementById("main-cart-items").dataset.id, selector: "#main-cart-items" },
                        { id: "cart-drawer", section: "cart-drawer", selector: "[data-cart-drawer]" },
                    ];
                },
            },
            {
                key: "updateQuantity",
                value: function (n, o, i, a) {
                    var c = this;
                    this.enableLoading(n);
                    var e = JSON.stringify({
                        line: n,
                        quantity: o,
                        sections: this.getSectionsToRender().map(function (e) {
                            return e.section;
                        }),
                        sections_url: window.location.pathname,
                    });
                    fetch("".concat(routes.cart_change_url), _objectSpread2(_objectSpread2({}, fetchConfig()), { body: e }))
                        .then(function (e) {
                            return e.text();
                        })
                        .then(function (e) {
                            var t,
                                r = JSON.parse(e);
                            0 === r.item_count && document.querySelector(".cart").classList.toggle("is-empty"),
                                c.getSectionsToRender().forEach(function (e) {
                                    (document.querySelector(e.selector) || document.getElementById(e.id)).innerHTML = c.getSectionInnerHTML(r.sections[e.section], e.selector);
                                }),
                                c.updateLiveRegions(n, r.item_count),
                                null === (e = document.getElementById("CartItem-".concat(n))) || void 0 === e || (null !== (t = e.querySelector('[name="'.concat(a, '"]'))) && void 0 !== t && t.focus()),
                                c.disableLoading(),
                                c.reorderBundles(),
                                0 != o || ((e = document.querySelector('input[value="'.concat(i, '"]'))) && (null !== (t = e.nextElementSibling) && void 0 !== t && t.classList.remove("button--added"), (e.checked = !1)));
                        })
                        .catch(function () {
                            c.loader.classList.add("hidden"), (document.getElementById("cart-errors").textContent = window.cartStrings.error), c.disableLoading();
                        })
                        .finally(function () {
                            c.cartDrawerSlider && window.dispatchEvent(new Event("build")),
                                c.cartDrawer.querySelectorAll("[data-cart-button-close]").forEach(function (e) {
                                    return e.addEventListener("click", c.cartDrawer.close.bind(c.cartDrawer));
                                });
                        });
                },
            },
            {
                key: "updateLiveRegions",
                value: function (e, t) {
                    this.currentItemCount === t &&
                        (document.getElementById("Line-item-error-".concat(e)).querySelector(".cart-item__error-text").innerHTML = window.cartStrings.quantityError.replace(
                            "[quantity]",
                            document.getElementById("Quantity-".concat(e)).value
                        )),
                        (this.currentItemCount = t),
                        this.lineItemStatusElement.setAttribute("aria-hidden", !0);
                    var r = document.getElementById("cart-live-region-text");
                    r.setAttribute("aria-hidden", !1),
                        setTimeout(function () {
                            r.setAttribute("aria-hidden", !0);
                        }, 1e3);
                },
            },
            {
                key: "getSectionInnerHTML",
                value: function (e, t) {
                    return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
                },
            },
            {
                key: "enableLoading",
                value: function (e) {
                    document.getElementById("main-cart-items").classList.add("cart__items--disabled"), this.loader.classList.remove("hidden"), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1);
                },
            },
            {
                key: "disableLoading",
                value: function () {
                    document.getElementById("main-cart-items").classList.remove("cart__items--disabled");
                },
            },
            {
                key: "reorderBundles",
                value: function () {
                    var n = document.querySelectorAll("[data-bundle-group]");
                    1 < n.length &&
                        [].slice
                            .call(n)
                            .sort(function (e, t) {
                                (e = e.dataset.bundleGroup), (t = t.dataset.bundleGroup);
                                return e < t ? -1 : t < e ? 1 : 0;
                            })
                            .forEach(function (e, t) {
                                var s,
                                    r = "bundle-" + e.dataset.bundleGroup;
                                document.getElementById(r).appendChild(e),
                                    t === n.length - 1 &&
                                        (s = document.querySelectorAll("[data-bundle-group-wrapper]")).forEach(function (e, t) {
                                            var r = document.createElement("div");
                                            r.classList.add("is-grid", "has-col-2", "has-col-1-lg", "cart-item__prices", "has-no-col-gap"), e.appendChild(r);
                                            var n = document.querySelector("[data-cart]").dataset.currency || "",
                                                o = document.querySelector("[data-cart]").dataset.vatText || "",
                                                i = parseInt(e.children[0].dataset.discountPrice) + parseInt(e.children[1].dataset.discountPrice),
                                                a = parseInt(e.children[0].dataset.originalPrice) + parseInt(e.children[1].dataset.originalPrice),
                                                c = n + formatMoney(i, "{{amount}}"),
                                                e = n + formatMoney(a, "{{amount}}"),
                                                o = '<div class="cart-item__price-wrapper is-flex is-flex-wrap is-aligned-baseline is-justified-end-lg grid-col-start-2 grid-col-start-1-sm" data-price-wrapper>\n              <div class="cart-item__discounted-prices price is-flex">\n                <span class="price-item price--sale text-medium">\n                  '
                                                    .concat(c, '\n                </span>\n                <s class="price-item price--compare text-medium">\n                  ')
                                                    .concat(e, "\n                </s>\n              </div>\n              ")
                                                    .concat("" != o ? '<span class="price-item price__vat text-x-small text-black-75">' + o + "</span>" : "", "\n            </div>");
                                            (r.innerHTML = o),
                                                document.querySelectorAll("[data-sale-badge]").forEach(function (e) {
                                                    var t = e.innerHTML.replace("[[amount]]", n + formatMoney(a - i, "{{amount}}"));
                                                    e.innerHTML = t;
                                                }),
                                                t === s.length - 1 &&
                                                    document.querySelectorAll("[data-bundle-group-wrapper]").forEach(function (e) {
                                                        var t = e.querySelectorAll("[data-bundle-group]")[0],
                                                            r = parseInt(t.dataset.productQuantity);
                                                        1 < r &&
                                                            ((t = document.createElement("span")).classList.add("cart-item__bundle-quantity", "text-medium"), (t.innerHTML = r + " x"), e.querySelector("[data-price-wrapper]").prepend(t));
                                                    });
                                        });
                            });
                },
            },
        ]),
        r
    );
})();
customElements.define("cart-items", CartItems),
    setTimeout(function () {
        document.querySelector("klarna-placement") && document.body.classList.add("klarna-added");
    }, 2500);
